export default "__VITE_ASSET__Dn8rPqY9__"